import Header from '../../components/Header'
import Footer from '../../components/Footer'

import './index.scss'

function News() {
	//const pageId = 0

	return (
		<div className="SOUKIASSIAN-News">
			<Header type="finalPage" title="TOUTES NOS ACTUALITÉS" />
			<Footer />
		</div>
	)
}

export default News
